import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Heart, Sparkles, Baby, MessageSquare, Ghost, Zap, Video, Skull, Star } from 'lucide-react';

const iconMap = {
  Heart,
  Sparkles,
  Baby,
  MessageSquare,
  Ghost,
  Zap,
  Video,
  Skull
};

const Services = ({ data }) => {
  return (
    <section id="services" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-1/2 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl animate-pulse" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            <span className="bg-gradient-to-r from-emerald-400 to-yellow-500 bg-clip-text text-transparent">
              Services
            </span>
            {' '}I Offer
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Comprehensive AI video solutions tailored to elevate your brand and engage your audience
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {data.map((service, index) => {
            const Icon = iconMap[service.icon];
            const delay = `delay-${Math.min(index * 100, 800)}`;
            return (
              <div key={service.id} className={`animate-scale-in ${delay}`}>
                <Card
                  className="group bg-slate-900/50 border-slate-800 hover:border-emerald-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-emerald-500/20 backdrop-blur-sm hover:-translate-y-2 h-full"
                >
                <CardHeader>
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-500/20 to-yellow-500/20 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 animate-breathe">
                    {Icon && <Icon className="w-7 h-7 text-emerald-400 group-hover:rotate-12 transition-transform animate-float" />}
                  </div>
                  
                  {/* Rating Badge */}
                  <div className="flex items-center gap-2 mb-2">
                    <Badge className="bg-yellow-500/20 text-yellow-400 border-yellow-500/30 flex items-center gap-1">
                      <Star className="w-3 h-3 fill-yellow-400" />
                      {service.rating}
                    </Badge>
                    <span className="text-xs text-slate-500">{service.reviews}</span>
                  </div>
                  
                  <CardTitle className="text-lg text-white group-hover:text-emerald-400 transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-400 text-sm">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-slate-500 text-xs group-hover:text-slate-400 transition-colors">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 group-hover:scale-150 transition-transform" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;